import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
// tslint:disable-next-line:max-line-length
import {
  MX_COMPANY_SEARCH_URL,
  MX_FMC_URL,
  MX_COMPANY_SEARCH_ADV_URL,
  // MX_COMPANY_SEARCH_FULLRESULT_URL,
  MX_CERT_URL,
  MX_LOOKUPS,
  MX_COMPANY_SEARCH_RESULT_URL,
  MX_COMPANY_SEARCH_BY_LOCATION_URL,
  MX_COMPANY_SEARCH_BY_NAME_URL,
  MX_COMPANY_SEARCH_SCOPE_URL,
  MX_CONTACT_URL, MX_COMPANY_SEARCH_FULLRESULT_URL
} from './app.constant';
import {ICompanySearch} from './app.model';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(private http: HttpClient) {
  }

  getCompany(company?: string, params?: any): Observable<HttpResponse<ICompanySearch[]>> {
    const queryParams = {
      query: company,
      size: params?.size || 10,
      page: params?.page || 0,
      sort: params?.sort || 'companylegalname,asc'
    };
    return this.http.get<ICompanySearch[]>(MX_COMPANY_SEARCH_URL, {
      params: queryParams,
      observe: 'response'
    });
  }

  searchServiceProvidersByLocation(params: any): Observable<any> {
    const queryParams = {
      ...params,
      size: params?.size || 10,
      page: params?.page || 0
    };
    return this.http.get(
      // MX_COMPANY_SEARCH_RESULT_URL, {
      // MX_COMPANY_SEARCH_FULLRESULT_URL, {
      MX_COMPANY_SEARCH_BY_LOCATION_URL, {
        params: queryParams,
        observe: 'response'
      });
  }

  searchServiceProvidersByName(company?: string, params?: any): Observable<any> {
    const queryParams = {
      ...params,
      query: company,
      size: params?.size || 10,
      page: params?.page || 0,
      sort: params?.sort || 'companylegalname,asc'
    };
    return this.http.get(
      MX_COMPANY_SEARCH_BY_NAME_URL, {
        params: queryParams,
        observe: 'response'
      });
  }

  searchIamTrustedServiceProvidersByLocation(params: any): Observable<any> {
    /*assocs=800&cacheBuster=0&
    ctry=United+States&
    lat=38.9072873&
    lng=-77.0369274&
    loc=Washington,+DC,+USA&
    query=q%3D+&
    range=50&
    sensor=false&
    sort=companylegalname,asc&
    supplier=&
    svc=IAMTrusted+Company
    */

    const queryParams = {
      ...params,
      assocs: 800,
      cacheBuster: 0,
      ctry: params.fromCountry,
      lat: params.fromLatitude,
      lng: params.fromLongitude,
      loc: params.fromLocation,
      query: 'q%3D+',
      range: 50,
      svc: 'IAMTrusted+Company',
      sort: 'companylegalname,asc',
      size: params?.size || 10,
      page: params?.page || 0
    };
    console.log('queryParams', queryParams);
    return this.http.get(
      // MX_COMPANY_SEARCH_RESULT_URL, {
      MX_COMPANY_SEARCH_FULLRESULT_URL, {
      // MX_COMPANY_SEARCH_BY_LOCATION_URL, {
        params: queryParams,
        observe: 'response'
      });
  }

  searchScope(params: any): Observable<any> {
    const queryParams = {
      fromLocation: params.fromLocation || '',
      fromLatitude: params.fromLatitude || '',
      fromLongitude: params.fromLongitude || '',
      fromCountry: params.fromCountry || '',
      toLocation: params.toLocation || '',
      toLatitude: params.toLatitude || '',
      toLongitude: params.toLongitude || '',
      toCountry: params.toCountry || ''
    };
    return this.http.get(MX_COMPANY_SEARCH_SCOPE_URL, {
      params: queryParams,
      observe: 'response'
    });
  }

  getAdvertisments(params: any): Observable<any> {
    return this.http.get(MX_COMPANY_SEARCH_ADV_URL, {
      params,
      observe: 'response'
    });
  }

  getLocalDateTime(timezoneOffset: any): any {
    const nd = this.getUTCDate(timezoneOffset);
    const minutes = nd.getMinutes() > 9 ? '' + nd.getMinutes() : '0' + nd.getMinutes();
    const seconds = nd.getSeconds() > 9 ? '' + nd.getSeconds() : '0' + nd.getSeconds();
    // tslint:disable-next-line:max-line-length
    return (nd.getMonth() + 1) + '/' + +nd.getDate() + '/' + nd.getFullYear() + ' ' + nd.getHours() + ':' + minutes + ':' + seconds;
  }

  getUTCDate(timezoneOffset) {
    const today = new Date();
    const utc = today.getTime() + (today.getTimezoneOffset() * 60000);
    const newOffset = timezoneOffset.split(':');
    // tslint:disable-next-line:radix
    const x = parseInt(newOffset[1]);
    if (x > 1) {
      timezoneOffset = '' + newOffset[0] + '.5';
    }

    return new Date(utc + (3600000 * timezoneOffset));
  }

  getFmcCert(organization: any): any {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(MX_FMC_URL + organization, {headers: headers, responseType: 'blob'});
  }

  downloadCert(membership: any, id: any): any {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(MX_CERT_URL + membership + '_CERT/' + id + '/%20', {headers: headers, responseType: 'blob'});
  }

  licensingCompliance(typeid: any, code: any): Observable<any> {
    return this.http.get(MX_LOOKUPS + typeid + '/' + code, {
      observe: 'response'
    });
  }

  submitContactForm(spId: any, contactData: any): Observable<any> {
    return this.http.post(MX_CONTACT_URL + spId + '/mover/contact', contactData, {
      observe: 'response'
    });
  }
}
